module.exports = __webpack_public_path__ + "img/status-promotion.5c5c75c8.png";